import { RootState } from '../store'
import { ChannelFont } from './channelFonts.interface'

export const channelFontsSelector = (state: RootState): ChannelFont[] =>
  state?.channelFonts?.data || []
